module.exports = __webpack_public_path__ + "src/assets/img/trafic_off.33f735aa.svg";